module.exports = __webpack_public_path__ + "img/background012.a4b18471.jpg";